import { API_URLS } from '../configuration/apiConstants';
import { apiFetch, apiFetchIkea } from '../configuration/apiFetch';
import { useCanvasStore } from '../store/canvasStore';
import { useSessionStore } from '../store/sessionStore';

export const getListMaps =  (id = null) => {
  console.log("getListMaps id", id);
  const myStore = useSessionStore.getState().myStore
  const storeId = id ?? myStore?.id
  const fetchSettings = {
    method: "GET",
    url: API_URLS.MAPS(storeId),
    params: {
      showImage: id ? true : false
    }
  }
  const dataFetch = new Promise ((resolve) => {
    apiFetch(fetchSettings).then((response)=>{
      resolve(response)
    })
  })
  return dataFetch
}

export const newMap =  (data, successMsg) => {
  const fetchSettings = {
    method: "POST",
    url: API_URLS.NEW_MAP,
    data,
    contentType: "multipart/form-data",
    successMsg
  }
  const dataFetch = new Promise ((resolve) => {
    apiFetch(fetchSettings).then((response)=>{
      resolve(response)
      useCanvasStore.getState().addToMaps(response)
    })
  })
  return dataFetch
}

export const getMap = ({mapId}) => {
  const fetchSettings = {
    method: "GET",
    url: API_URLS.MAP(mapId),
    params: {
      showImage: false
    }
  }
  const dataFetch = new Promise ((resolve) => {
    apiFetch(fetchSettings).then((response)=>{
      resolve(response)
    })
  })
  return dataFetch
}

export const updateMap =  ({mapId,data, successMsg}) => {
  const fetchSettings = {
    method: "PUT",
    url: API_URLS.MAP(mapId),
    data,
    contentType: "multipart/form-data",
    successMsg
  }
  const dataFetch = new Promise ((resolve) => {
    apiFetch(fetchSettings).then((response)=>{
      resolve(response)
    })
  })
  return dataFetch
}

export const changeMapRoute = ({data, msgs, route}) => {
  let fetchSettings
  if(route === null){
    fetchSettings = {
      method: "POST",
      url: API_URLS.NEW_ROUTE,
      data,
      successMsg: msgs.post
    }
    
  }else if(route !== null && data.point !== "[]"){
    fetchSettings = {
      method: "PUT",
      url: API_URLS.ROUTE(route.id),
      data,
      successMsg: msgs.put
    }
    
  }else if(route !== null && data.point === "[]"){
    fetchSettings = {
      method: "DELETE",
      url: API_URLS.ROUTE(route.id),
      successMsg: msgs.del
    }
    
  }
  
  const dataFetch = new Promise ((resolve) => {
    apiFetch(fetchSettings).then((response)=>{
      resolve(response || null)
    })
  })
  return dataFetch
}

export const getAddons = ({mode, level}) => {
  const fetchSettings = {
    method: "GET",
    url: mode+"s/"+level
  }
  const dataFetch = new Promise ((resolve) => {
    apiFetch(fetchSettings).then((response)=>{
      resolve(response)
    })
  })
  return dataFetch
}

export const saveAddon = ({type, mode, addon, addonEdit, points, mapId, level, successMsg}) => {
  const storeId = useSessionStore.getState().myStore?.id
  const data = {
    ...addon,
    point: points,
    ...(level === 0 ? {mapId: mapId} : {sectionId: mapId}),
  }
  const fetchSettings = {
    method: type,
    url: type === "POST" ? mode + `?storeId=${storeId}` : mode + `/${addonEdit.id}?storeId=${storeId}`,
    data,
    successMsg
  }
  const dataFetch = new Promise ((resolve) => {
    apiFetch(fetchSettings).then((response)=>{
      resolve(response)
    })
  })
  return dataFetch
}

export const deleteAddon = ({mode, id, successMsg}) => {
  const storeId = useSessionStore.getState().myStore?.id
  const fetchSettings = {
    method: "DELETE",
    url: `${mode}/${id}?storeId=${storeId}`,
    successMsg
  }
  const dataFetch = new Promise ((resolve) => {
    apiFetch(fetchSettings).then(()=>{
      resolve()
    })
  })
  return dataFetch
}

export const getSectionsTypes =  (mode) => {
  const fetchSettings = {
    method: "GET",
    url: mode === "section" ? API_URLS.SECTION_TYPES : API_URLS.SUB_SECTIONS
  }
  const dataFetch = new Promise ((resolve) => {
    apiFetch(fetchSettings).then((response)=>{
      resolve(response)
    })
  })
  return dataFetch
}

export const getSubtypes =  (type, fatherValue) => {
  const PA_OR_HFB = "1"
  const fetchSettings = {
    method: "GET",
    url: API_URLS.SU_OPTIONS,
    params: {
      subOptions: type.nameSubOption,
      ...(type.value === PA_OR_HFB ? {value: fatherValue} : {})
    }
  }
  const dataFetch = new Promise ((resolve) => {
    apiFetch(fetchSettings).then((response)=>{
      resolve(response)
    })
  })
  return dataFetch
}

export const savePolygon =  ({type, data, polygon, successMsg}) => {
  const fetchSettings = {
    method: type,
    url: type === "POST" ? API_URLS.NEW_SECTION : API_URLS.SECTION(polygon.id),
    data,
    successMsg
  }
  const dataFetch = new Promise ((resolve) => {
    apiFetch(fetchSettings).then((response)=>{
      resolve(response)
    })
  })
  return dataFetch
}

//SECTION VIEW
export const getSection = (sectionId) => {
  const fetchSettings = {
    method: "GET",
    url: API_URLS.SECTION(sectionId),
    params: {
      showImage: false
    }
  }
  const dataFetch = new Promise ((resolve) => {
    apiFetch(fetchSettings).then((response)=>{
      resolve(response)
    })
  })
  return dataFetch
}

export const getIkeaProducts = (ref) => {
  const lang = useSessionStore.getState().language
  const fetchSettings = {
    method: "GET",
    url: API_URLS.SALES_ITEM,
    params: {
      languageCode: lang, 
      itemNos: ref
    }
  }
  const dataFetch = new Promise ((resolve) => {
    apiFetchIkea(fetchSettings).then((response)=>{
      resolve(response)
    })
  })
  return dataFetch
}

export const deleteMap = ({ params, successMsg }) => {
  const fetchSettings = {
    method: "PUT",
    url: API_URLS.DELETE_MAP,
    params, 
    successMsg
  }
  const dataFetch = new Promise ((resolve) => {
    apiFetch(fetchSettings).then(()=>{
      resolve()
    })
  })
  return dataFetch
}